import HistoricalIndexWidget from './widget'
import {
  useGetHistoryIndexSitesQuery,
  useLazyGetHistoryIndexChartQuery,
} from '../../../store/api'
import Mixpanel from '../../../utils/mixpanel/Mixpanel'

export default function HistoricalIndexChart() {
  const { data: sites, isSuccess: isSitesLoaded } =
    useGetHistoryIndexSitesQuery({})
  const [
    getChartData,
    { data, currentData, isLoading, isFetching, isSuccess },
  ] = useLazyGetHistoryIndexChartQuery()

  return (
    <div className="mb-8">
      <HistoricalIndexWidget
        sites={sites}
        isSitesLoaded={isSitesLoaded}
        chartData={currentData ?? data}
        isLoading={isLoading}
        isFetching={isFetching}
        isSuccess={isSuccess}
        // preferCacheValue: a lazy trigger refetches even when the args are
        // already cached, which would defeat the endpoint's
        // keepUnusedDataFor when flipping back to a previously-viewed tab.
        onFilterChange={({ siteIds, startAt, endAt }) =>
          getChartData({ siteIds, startAt, endAt }, true)
        }
        onTabClick={(event) =>
          Mixpanel.track(event, {
            page: 'Dashboard',
            section: 'Historical Index Chart',
          })
        }
      />
    </div>
  )
}
